import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import { getDeviceContract } from '../reducers';

const withDeviceContract = (DecoratedComponent) => {
  let WithDeviceContract = ({ children, ...props }) => {
    return React.createElement(DecoratedComponent, props, children);
  };

  const mapStateToProps = (
    state,
    {
      match: {
        params: { deviceContractId },
      },
    },
  ) => {
    const deviceContract = getDeviceContract(state, deviceContractId);

    return {
      deviceContract,
      deviceContractId,
    };
  };

  WithDeviceContract = withRouter(
    connect(mapStateToProps, null)(WithDeviceContract),
  );

  const WithDeviceContractRoute = ({ children, ...props }) => (
    <Route
      path="/device/contracts/:deviceContractId"
      component={WithDeviceContract}
      {...props}
    />
  );

  return WithDeviceContractRoute;
};

export default withDeviceContract;
